import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRewardRoute } from '@/common/reward/route.registry';
import { InjectionFeature } from '@/common/reward/types';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_CREDIT } from './router';

export default registerRouteForModule(router);

registerRewardRoute(InjectionFeature.CreditTicket, {
    routeToIndexPage: () => ({ name: ROUTE_NAME_CREDIT.TICKET.INDEX }),
    routeToInfoPage: () => ({ name: ROUTE_NAME_CREDIT.TICKET.INDEX })
});

menuRegistry.registerMenu([
    {
        parent: 'Multiplayer',
        key: 'CreditTicket',
        name: 'Credit Ticket',
        icon: 'fas fa-ticket-alt',
        route: { name: ROUTE_NAME_CREDIT.TICKET.INDEX }
    }
]);
